module.exports = __webpack_public_path__ + "img/tron-logo.de3064d6.png";